module.exports = __webpack_public_path__ + "static/media/backgroundSuccess.4b36c99f.png";